import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../auth/authentication.service";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  private ENDPOINT_PROJECT = "/v4/projects";
  private ENDPOINT_PROJECT_POST = "/projects";
  private ENDPOINT_PROJECT_LIST = "/v4-1/projects";
  private ENDPOINT_PROJECT_PICKLIST = "/projects/pick-list";
  private ENDPOINT_PROJECT_CATEGORIES = "/project-categories";
  private ENDPOINT_PROJECT_TYPES = "/project-types";
  private UPDLOAD_PARENT_TYPE = "PROJECT_ATTACHMENT";
  private ENDPOINT_PROJECT_CONTACTS = "/contacts";
  private ENDPOINT_GET_ATTACHMENTS_BY_PROJECT_ID = "/v4/attachments/project"
  private ENDPOINT_DELETE_ASSET_FROM_PROJECT = "/assets/unlink/project";
  private ENDPOINT_PROJECT_MILESTONES = "/project-milestones";

  private selectSubject = new Subject();

  public select(val: any) {
    this.selectSubject.next(val);
  }

  public getSelectItem() {
    return this.selectSubject.asObservable();
  }

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {}

  public createProject(formData: any) {
    return this.http
      .post(`${environment.base_url}${this.ENDPOINT_PROJECT_POST}`, formData)
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public updateProject(formData: any) {
    return this.http
      .put(`${environment.base_url}${this.ENDPOINT_PROJECT_POST}`, formData)
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getAllProjects(
    serverParams: any,
    searchValue: string,
    projectType: any | null,
    serviceZone: any | null,
    categoryId: any | null,
    geofenceId: any | null,
    siteId: any | null,
    customerId: any | null,
    origin: any | null,
    projectIdsToSkip: any | null,
    assetsId: any = null
  ) {
    let params = new HttpParams();

    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }

    if (projectType !== "" && projectType != null) {
      params = params.set("projectType", projectType);
    }

    if (serviceZone !== "" && serviceZone != null) {
      params = params.set("serviceZoneId", serviceZone);
    }

    if (categoryId !== "" && categoryId != null) {
      params = params.set("categoryId", categoryId);
    }

    if (geofenceId !== "" && geofenceId != null) {
      params = params.set("geofenceId", geofenceId);
    }

    if (siteId !== "" && siteId != null) {
      params = params.set("siteId", siteId);
    }

    if (customerId !== "" && customerId != null) {
      params = params.set("customerId", customerId);
    }

    if (origin !== "" && origin != null) {
      params = params.set("origin", origin);
    }

    if (projectIdsToSkip !== "" && projectIdsToSkip != null) {
      params = params.set(
        "projectIdsToSkip",
        Array.isArray(projectIdsToSkip) ? projectIdsToSkip.join(",") : String(projectIdsToSkip)
      );
    }

    if (assetsId) {
      params = params.set("assetsId", String(assetsId));
    }

    if (serverParams) {
      params = params
        .set("startFrom", serverParams.startRow)
        .set("perPage", "25")
        .set("columnName", (serverParams.sortModel[0] as any).colId)
        .set("sortOrder", (serverParams.sortModel[0] as any).sort);
    }

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_LIST}`, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getProjectById(id: any) {
    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT}/${String(id)}`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public deleteProject(projectId: any) {
    return this.http
      .delete(
        `${environment.base_url}${this.ENDPOINT_PROJECT_POST}/${String(projectId)}`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          console.log(resp);
          
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getAllProjectPickList(searchValue: string | null, assetsId?: any, customerId?: any, siteId?: any) {
    let params = new HttpParams();

    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }

    if (assetsId) {
      params = params.set("assetsId", String(assetsId));
    }

    if (customerId) {
      params = params.set("customerId", String(customerId));
    }

    if (siteId) {
      params = params.set("siteId", String(siteId));
    }

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_PICKLIST}`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  /******************************************** CATEGORY ******************************************/
  public getAllProjectCategories(
    isActive: boolean | null,
    isOrder: boolean | null
  ) {
    let params = new HttpParams();

    if (isActive !== null && (isActive === true || isActive === false)) {
      params = params.set("isActive", String(isActive));
    }

    if (isOrder !== null && (isOrder === true || isOrder === false)) {
      params = params.set("isOrder", String(isOrder));
    }

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_CATEGORIES}`, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public createProjectCategory(formData: any) {
    return this.http
      .post(
        `${environment.base_url}${this.ENDPOINT_PROJECT_CATEGORIES}`,
        formData
      )
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public updateProjectCategory(formData: any) {
    return this.http
      .put(
        `${environment.base_url}${this.ENDPOINT_PROJECT_CATEGORIES}`,
        formData
      )
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public deleteProjectCategory(projectCategoryId: any) {
    return this.http
      .delete(
        `${environment.base_url}${this.ENDPOINT_PROJECT_CATEGORIES}/${String(
          projectCategoryId
        )}`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  /******************************************** TYPE ******************************************/
  public getAllProjectTypes(isActive: boolean | null) {
    let params = new HttpParams();

    if (isActive !== null && (isActive === true || isActive === false)) {
      params = params.set("isActive", String(isActive));
    }

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_TYPES}`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public createProjectTypes(formData: any) {
    return this.http
      .post(`${environment.base_url}${this.ENDPOINT_PROJECT_TYPES}`, formData)
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public updateProjectTypes(formData: any) {
    return this.http
      .put(`${environment.base_url}${this.ENDPOINT_PROJECT_TYPES}`, formData)
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public deleteProjectType(projectTypeId: any) {
    return this.http
      .delete(
        `${environment.base_url}${this.ENDPOINT_PROJECT_TYPES}/${String(
          projectTypeId
        )}`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getListColumn(apiModule: any) {
    return this.http
      .get(
        environment.base_url +
          "/table-column-setups/by-module?apiModule=" +
          apiModule
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public uploadAttachment(id: any, formData: any) {
    const headers = new HttpHeaders({
      "Authorization": "Bearer " + this.auth.getToken()
    });

    return this.http
      .post(
        environment.base_url +
          `/attachments/upload?parentType=${this.UPDLOAD_PARENT_TYPE}&parentId=` +
          id,
        formData,
        { headers: headers, observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error: any) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public getProjectContact(projectId: any | null, searchValue?: string) {
    let params = new HttpParams();

    if (projectId !== null && projectId !== "") {
      params = params.set("projectId", String(projectId));
    }
    if(searchValue){
      params = params.set('search', searchValue);
    }
    return this.http
      .get(
        `${environment.base_url}${this.ENDPOINT_PROJECT_CONTACTS}/by-project`,
        {
          observe: "response",
          params: params,
        }
      )
      .pipe(
        map((resp: any) => {
          if (resp.status === 200) {
            return resp.body;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public createProjectContact(formData: any) {
    return this.http
      .post(
        `${environment.base_url}${this.ENDPOINT_PROJECT_CONTACTS}`,
        formData
      )
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public updateProjectContact(formData: any) {
    return this.http
      .put(`${environment.base_url}${this.ENDPOINT_PROJECT_CONTACTS}`, formData)
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getProjectTasks(siteId: any) {
    return this.http
      .get(`${environment.base_url}/projects/${siteId}/tasks`)
      .pipe(
        map((resp: any) => {
          if (resp) {
            return resp;
          } else {
            throwError(resp);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

    /************************************* Get Project Attachments Info By ID *************************************************************************/
    public getAttachmentsByProjectId(id: any) {
      let params = new HttpParams();
      params = params.set("projectId", id);
      return this.http
        .get(environment.base_url + this.ENDPOINT_GET_ATTACHMENTS_BY_PROJECT_ID,
          {params : params})
        .pipe(
          map((resp: any) => {
            return resp;
          }),
          catchError((error) => {
            ////console.log(error);
            return throwError(error);
          })
        );
    }

  /** GET /project-milestones?projectId= */
  public getProjectMilestonesByProject(projectId: any) {
    const params = new HttpParams().set("projectId", String(projectId));
    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  public getProjectMilestones(projectId: any, searchValue: string | null, parameters: any) {
    const pageSize = parameters?.pageSize || 10;
    const startFrom = parameters?.startRow || 0;
    const sort = parameters?.sortModel?.[0];

    let params = new HttpParams()
      .set("page", String(Math.floor(startFrom / pageSize) + 1))
      .set("perPage", String(pageSize))
      .set("startFrom", String(startFrom))
      .set("columnName", sort?.colId || "id")
      .set("sortOrder", sort?.sort || "asc");

    if (projectId !== "" && projectId != null) {
      params = params.set("projectId", String(projectId));
    }

    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}/paged`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  /** GET /project-milestones/{id}/job-orders?page&perPage */
  public getProjectMilestoneJobOrders(id: any, page = 1, perPage = 10) {
    const params = new HttpParams()
      .set("page", String(page))
      .set("perPage", String(perPage));

    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}/${id}/job-orders`, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  public getProjectMilestoneById(id: any) {
    return this.http
      .get(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}/${id}`, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  public createProjectMilestone(formData: any) {
    return this.http
      .post(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}`, formData, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  /** DELETE /project-milestones/{id} */
  public deleteProjectMilestone(id: any) {
    return this.http
      .delete(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}/${id}`, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  /** PUT /project-milestones/{id}/to-status/{status} */
  public updateProjectMilestoneStatus(id: any, status: string) {
    return this.http
      .put(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}/${id}/to-status/${status}`, {}, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  public updateProjectMilestone(formData: any) {
    return this.http
      .put(`${environment.base_url}${this.ENDPOINT_PROJECT_MILESTONES}`, formData, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  deleteAssetFromProject(assetId: any){
    let apiUrl: string = `${environment.base_url}${this.ENDPOINT_DELETE_ASSET_FROM_PROJECT}?assetsId=${assetId}`;
    return this.http.put(apiUrl, {}, { observe: "response" }).pipe(
      map((resp: any) => resp),
      catchError((error) => throwError(() => error)),
    );
  }
}
// Summary of changes:

// ✅ Removed deprecated imports:

// Removed import { Headers, Http, RequestOptions } from "@angular/http";


// ✅ Updated constructor:

// Removed private httpOld: Http parameter


// ✅ Updated uploadAttachment method:

// Changed from using Headers and RequestOptions to HttpHeaders
// Changed from httpOld (old Http service) to http (HttpClient)
// Simplified the headers configuration



// The code should now compile successfully with Angular 19!